export default __webpack_public_path__ + "static/media/insta-icon.4683ae0d.png";